export const hotlineTelNumber = "48 579779990";
